import React from "react";

const ManagerSelectedEmployeeCard = (props) => {
  const title = props.title;
  const employee = props.employee;

  // test
  console.log("card title:", title);
  console.log("card employee:", employee);
  console.log("card employeeName:", employee?.employeeName);

  if(!employee) return <p>Loading...</p>

  return(
    <div className="manager_feedback_employee_side">
      <p className="manager_feedback_select_employee">{title}</p>

      <div className="manager_selected_employee_card">
        <p className="manager_feedback_quizlist_employee">{employee.employeeName}</p>

        {employee.photo && (
          <img 
            src={employee.photo}
            alt={employee.employeeName}
            className="manager_selected_employee_photo"/>
        )
        }
      </div>

    </div>
  )
}

export default ManagerSelectedEmployeeCard;